export default __webpack_public_path__ + "static/media/hotspot.d2299547.svg";